import { useDispatch, useSelector } from "react-redux";
import {
  getUser,
  getUsers,
  selectIsLoggedIn,
} from "../../../redux/features/auth/authSlice";
import { useEffect, useState } from "react";
import Search from "../../search/Search";
import { Spinner } from "../../loader/Loader";
import { shortenText } from "../../../utils";
import ReactPaginate from "react-paginate";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const ViewUsers = () => {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { users, isLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getUsers());
      dispatch(getUser());
    }
  }, [isLoggedIn, dispatch]);

  // Begin Pagination
  const itemsPerPage = 6;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = users?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(users?.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % users?.length;
    setItemOffset(newOffset);
  };

  //  End Pagination

  const updateRole = (e) => {
    e.preventDefault();
    console.log("update");
  };

  return (
    <section>
      <div className="container product-list">
        <div className="table">
          <div className="--flex-between --flex-dir-column">
            <span>
              <h3>All Users</h3>
              <p>
                ~ <b>{users?.length}</b> Users found
              </p>
            </span>
            <span>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </span>
          </div>
        </div>

        {isLoading && <Spinner />}

        <form onSubmit={updateRole}>
          <div className="table">
            {!isLoading && users?.length === 0 ? (
              <p>No user found...</p>
            ) : (
              <table>
                <thead>
                  <td>s/n</td>
                  <td>id</td>
                  <td>Email</td>
                  <td>Role</td>
                  <td>Action</td>
                </thead>

                <tbody>
                  {currentItems?.map((user, index) => {
                    const { _id, email, role } = user;
                    return (
                      <tr key={_id}>
                        <td>{index + 1}</td>
                        <td>{shortenText(_id, 16)}</td>
                        <td>{email}</td>
                        <td>
                          <select
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                role: e.target.value,
                              })
                            }
                          >
                            <option value="uncategorized">{role}</option>
                            <option value="admin">Admin</option>
                          </select>
                        </td>
                        <td>
                          <button className="--btn-primary --btn-block">
                            Update Role
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </form>
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="Prev"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          pageLinkClassName="page-num"
          previousLinkClassName="page-num"
          nextLinkClassName="page-num"
          activeLinkClassName="activePage"
        />
      </div>
    </section>
  );
};
export default ViewUsers;
